module.exports = __webpack_public_path__ + "static/media/inBuilding.c1a95f73.svg";